import { render } from "./TeamImportModal.vue?vue&type=template&id=2d8f8ee7"
import script from "./TeamImportModal.vue?vue&type=script&lang=js"
export * from "./TeamImportModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__